"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import Image from "./webflow_modules/Basic/components/Image";

export function HeroSliderSlide({
  bottomTextText = "Sunnyvale ca",
  heroSliderSlideImageImage = "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/656beec750c7f84477e2c301_Rectangle%2093.png",
  imagePriority = "auto",
  topTextText = "1250 Lakeside",
}) {
  return (
    <Block className={"hero-slider_slide-wrapper"} tag={"div"}>
      <Block className={"hero-slider_image-description"} tag={"div"}>
        <Block className={"hero-slider_image-description-wrapper"} tag={"div"}>
          <Block className={"text-24"} tag={"div"}>
            {topTextText}
          </Block>
          <Block className={"text-25"} tag={"div"}>
            {bottomTextText}
          </Block>
        </Block>
      </Block>
      <Block className={"hero-slider_slide-image-wrapper"} tag={"div"}>
        <Image
          alt={""}
          className={"hero-slider_slide-image"}
          // @ts-ignore - User-defined custom attribute(s)
          fetchPriority={imagePriority}
          height={"auto"}
          loading={"eager"}
          src={heroSliderSlideImageImage}
          width={"auto"}
        />
      </Block>
    </Block>
  );
}
